import Loader from '@monofront/design-system/components/Button/Loader';
import { usePaymentFormContext } from '../FormContext';

interface ISubmitButtonProps {
  buttonLabel: string;
  disabled?: boolean;
  UNSAFE_className?: string;
}

const SubmitButton: React.FC<ISubmitButtonProps> = ({
  buttonLabel,
  disabled = false,
  UNSAFE_className = '',
}) => {
  const { isLoading } = usePaymentFormContext();

  return (
    <button
      type="submit"
      className={`${UNSAFE_className} tw-lf-button tw-lf-button-primary tw-lf-button-md`}
      disabled={disabled}
      data-testid="PaymentFormSubmitButton"
    >
      {isLoading ? <Loader /> : buttonLabel}
    </button>
  );
};

export default SubmitButton;
